import React, { Component } from 'react'
import Switch from "react-switch";
import { Notifications } from '../../common/notification';
import { getUser } from '../../../actions/session';
import Axios from 'axios';
import { GATEWAY_CREATE } from '../../../config/rest_endpoints';
import ReactTooltip from 'react-tooltip';


 class AddGateway extends Component {
     constructor(props) {
         super(props)
         this.state = {
             User:getUser(),
            switched:true,
            ip:'',
            sessions: '',
             port:5060,
            cps: '',
            prefix: '',
            isLoad:false
         }
         this.onHandleChange = this.onHandleChange.bind(this)
         this.onSubmit = this.onSubmit.bind(this)
         this.toggleSwitch = this.toggleSwitch.bind(this)
     }

     toggleSwitch() {
         this.setState({switched:!this.state.switched})
     }

     onHandleChange(e) {
         this.setState({
             [e.target.name]:e.target.value
         })
     }

     onSubmit() {
        const {User,switched,ip,port,sessions,cps,prefix} = this.state
        var userId = this.props.ID
        console.log('userId :>> ', userId);
        var payload = {
            "status":switched,
            "ip":ip,
            "port": parseInt(port),
            "cps" : cps === '' ? null : parseInt(cps),
            "sessions": sessions === '' ? null : parseInt(sessions),
            "prefix":prefix === '' ? null : prefix
        }
         this.setState({ isLoad: true })
        var headers = { 'Authorization': "Bearer " + User.token }
        Axios.post(`${GATEWAY_CREATE}/${userId}/gateway/create`, payload, { headers }).then(res => {
            if (res) {
               console.log('res :>> ', res);
               Notifications.notify("Gateway created", "Success", "success")
               this.props.close()
               this.props.listing()
                this.setState({ isLoad: false, cps: '', sessions: '', ip: '', prefix: '' })
            }
            else {
                Notifications.notify("failed carrier update", "Failed", "error")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false,
                isLoad: false
            })
        })

     }
     
    render() {
        const {switched,ip,port,sessions,cps,prefix} = this.state

        const labelStyle = {
            fontWeight: '500',
            fontSize: '13px',
            color: '#475569',
            marginBottom: '6px'
        };

        return (
            <div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>IP</label>
                            <input type="text" className="form-control" name="ip" value={ip} onChange={this.onHandleChange} placeholder="Enter gateway ip" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Port</label>
                            <input type="number" className="form-control" name="port" value={port} onChange={this.onHandleChange} placeholder="Enter gateway port" />
                        </div>
                    </div>
                    <div className="col-md-12" style={{marginBottom:'16px'}}>
                        <div style={{
                            display:'flex',
                            alignItems:'flex-start',
                            gap:'10px',
                            padding:'12px 16px',
                            background:'#F0F9FF',
                            borderRadius:'10px',
                            border:'1px solid #BAE6FD'
                        }}>
                            <i className="fas fa-info-circle" style={{fontSize:'14px',color:'#3B82F6',marginTop:'2px',flexShrink:0}}></i>
                            <span style={{fontSize:'12px',color:'#475569',lineHeight:'1.5'}}>
                                Traffic between gateways is always load-balanced. Use the fields below only if your gateways have different CPS/session limits. Otherwise, for performance reasons, it's best to use only the carrier's CPS/session limits.
                            </span>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Sessions</label>
                            <input type="number" className="form-control" name="sessions" value={sessions} onChange={this.onHandleChange} placeholder="Enter sessions" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>CPS</label>
                            <input type="number" className="form-control" name="cps" value={cps} onChange={this.onHandleChange} placeholder="Enter cps" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Prefix</label>
                            <input type="text" className="form-control" name="prefix" value={prefix} onChange={this.onHandleChange} placeholder="e.g. 3353#" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group" style={{marginTop:'4px'}}>
                            <label style={labelStyle}>Status</label>
                            <div style={{marginTop:'4px'}}>
                                <Switch onChange={this.toggleSwitch} checked={switched} onColor="#10B981" offColor="#CBD5E1" height={22} width={44} handleDiameter={18} />
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{borderTop:'1px solid #E2E8F0',marginTop:'16px',paddingTop:'20px',display:'flex',justifyContent:'flex-end'}}>
                    <button
                        type="submit"
                        onClick={this.onSubmit}
                        style={{
                            background: this.state.isLoad ? '#94A3B8' : 'linear-gradient(135deg, #10B981, #059669)',
                            color: '#FFFFFF',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '13px',
                            fontWeight: '600',
                            cursor: this.state.isLoad ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: this.state.isLoad ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.3)',
                            transition: 'all 200ms ease'
                        }}
                    >
                        Add Gateway
                        <i className={this.state.isLoad ? "icon-spinner4 spinner" : "icon-file-plus"} style={{fontSize:'14px'}}></i>
                    </button>
                </div>
            </div>
        )
    }
}
export default AddGateway